exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.no-vehicles[data-v-607fe0f0]{\r\n    width: 100%;\r\n    text-align: center;\n}\n.no-vehicles p[data-v-607fe0f0]{\r\n    font-size: 1.5em;\r\n    font-weight: 300;\r\n    margin: 24px auto;\r\n    max-width: 240px;\n}\n.no-vehicles a[data-v-607fe0f0]{\r\n    font-weight: 600;\r\n    color: #2C61D5;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-607fe0f0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/garage/no-vehicles.vue
// module id = 598
// module chunks = 0